import { SpreadsheetReference } from "@common/schemas/spreadsheetReference.schema";

/** Builds a stable React key for a SpreadsheetReference. */
export function buildRefKey(ref: SpreadsheetReference): string {
    return `${ref.taskId}::${ref.source}::${ref.cells.map((c) => c.rowKey + "-" + c.columnKey).join(",")}`;
}
